import React from 'react';
import { FaCheckCircle, FaUsers, FaMicrochip } from 'react-icons/fa';

const WhyChooseUs = () => {
  const features = [
    {
      icon: <FaCheckCircle size={48} />,
      title: 'Reliable Service Delivery',
      description: 'We are committed to delivering consistent, high-quality services that exceed expectations. Our dedication to quality speaks for itself.',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      icon: <FaUsers size={48} />,
      title: 'Extended Workforce',
      description: 'Our skilled team of professionals ensures scalable support for projects of any size, anywhere across North America.',
      gradient: 'from-cyan-500 to-teal-500'
    },
    {
      icon: <FaMicrochip size={48} />,
      title: 'Tech-Focused Philosophy',
      description: 'We embrace cutting-edge technology to provide innovative solutions that keep your business ahead of the curve.',
      gradient: 'from-indigo-500 to-blue-500'
    }
  ];

  return (
    <section id="why-choose" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">NextGen</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We deliver excellence in telecommunications with our proven approach
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative"
            >
              {/* Card */}
              <div className="relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 h-full">
                {/* Icon */}
                <div className="flex justify-center mb-6">
                  <div className={`w-24 h-24 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center text-white transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-lg`}>
                    {feature.icon}
                  </div>
                </div>

                {/* Content */}
                <div className="text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>

                {/* Decorative border on hover */}
                <div className={`absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r ${feature.gradient} rounded-b-3xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
